import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styles: []
})
export class FooterComponent {

  anio:number = new Date().getFullYear();

}



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/components/footer/footer.component.ts